import { apiClient } from "@/lib/api";

// Organisation hierarchy — admin-managed tree that mirrors the future
// time-registration ("urenregistratie") hierarchy. `parentId` = leidinggevende.

export interface OrgNodeUser {
  id: string;
  displayName: string;
  email: string;
  isActive: boolean;
}

export interface OrgNode {
  id: string;
  name: string;
  userId: string | null;
  parentId: string | null;
  externalReference1: string | null;
  externalReference2: string | null;
  externalReference3: string | null;
  externalReference4: string | null;
  externalReference5: string | null;
  childCount: number;
  user: OrgNodeUser | null;
  createdAt: string;
  updatedAt: string;
}

export interface OrgNodeInput {
  name?: string;
  parentId?: string | null;
  userId?: string | null;
  externalReference1?: string | null;
  externalReference2?: string | null;
  externalReference3?: string | null;
  externalReference4?: string | null;
  externalReference5?: string | null;
}

export function listOrgNodes(): Promise<OrgNode[]> {
  return apiClient.get<OrgNode[]>("/api/v1/org-nodes");
}

// RBAC (admin-only) is enforced server-side.
export function createOrgNode(input: OrgNodeInput & { name: string }): Promise<OrgNode> {
  return apiClient.post<OrgNode>("/api/v1/org-nodes", input);
}

export function updateOrgNode(id: string, input: OrgNodeInput): Promise<OrgNode> {
  return apiClient.patch<OrgNode>(`/api/v1/org-nodes/${id}`, input);
}

export function deleteOrgNode(id: string): Promise<{ id: string; deleted: boolean }> {
  return apiClient.delete<{ id: string; deleted: boolean }>(`/api/v1/org-nodes/${id}`);
}

// Active WLX users for the "link to user" picker. The org tree is small; a
// single generous page is plenty and keeps the picker simple.
export async function listOrgUsers(): Promise<OrgNodeUser[]> {
  const res = await apiClient.get<{ data: OrgNodeUser[] }>("/api/v1/users", {
    limit: "200",
    isActive: "true",
  });
  return res.data.map((u) => ({
    id: u.id,
    displayName: u.displayName,
    email: u.email,
    isActive: u.isActive,
  }));
}

export const orgKeys = {
  list: ["org-nodes"] as const,
  users: ["org-nodes", "users"] as const,
};
